<div class="w-12 c1"
     style="min-height:1px;"
     *iCms="'text' of content"></div>